import { render, staticRenderFns } from "./the-ultimate-guide-to-eating-plant-based.vue?vue&type=template&id=0a6bd0c4&"
import script from "./the-ultimate-guide-to-eating-plant-based.vue?vue&type=script&lang=js&"
export * from "./the-ultimate-guide-to-eating-plant-based.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderLandingPageThankYou: require('/opt/build/repo/components/HeaderLandingPageThankYou.vue').default})
